/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface GeoElectricMeasure
 */
export interface GeoElectricMeasure {
  /**
   *
   * @type {string}
   * @memberof GeoElectricMeasure
   */
  readonly uuid?: string;
  /**
   *
   * @type {Date}
   * @memberof GeoElectricMeasure
   */
  readonly created?: Date;
  /**
   *
   * @type {Date}
   * @memberof GeoElectricMeasure
   */
  readonly updated?: Date;
  /**
   *
   * @type {string}
   * @memberof GeoElectricMeasure
   */
  resistance?: string | null;
  /**
   *
   * @type {string}
   * @memberof GeoElectricMeasure
   */
  relatedMeasurementConfiguration?: string | null;
  /**
   *
   * @type {string}
   * @memberof GeoElectricMeasure
   */
  geoElectricMeasurement: string;
  /**
   *
   * @type {string}
   * @memberof GeoElectricMeasure
   */
  dataOwner: string;
}

/**
 * Check if a given object implements the GeoElectricMeasure interface.
 */
export function instanceOfGeoElectricMeasure(value: object): value is GeoElectricMeasure {
  if (
    (!("geoElectricMeasurement" in (value as Record<string, any>)) &&
      !("geo_electric_measurement" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["geoElectricMeasurement"] === undefined &&
      (value as Record<string, any>)["geo_electric_measurement"] === undefined)
  )
    return false;
  if (
    (!("dataOwner" in (value as Record<string, any>)) &&
      !("data_owner" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["dataOwner"] === undefined &&
      (value as Record<string, any>)["data_owner"] === undefined)
  )
    return false;
  return true;
}

export function GeoElectricMeasureFromJSON(json: any): GeoElectricMeasure {
  return GeoElectricMeasureFromJSONTyped(json, false);
}

export function GeoElectricMeasureFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GeoElectricMeasure {
  if (json == null) {
    return json;
  }
  return {
    uuid: json["uuid"] == null ? undefined : json["uuid"],
    created: json["created"] == null ? undefined : new Date(json["created"]),
    updated: json["updated"] == null ? undefined : new Date(json["updated"]),
    resistance:
      json["resistance"] === undefined
        ? undefined
        : json["resistance"] === null
        ? null
        : json["resistance"],
    relatedMeasurementConfiguration:
      json["related_measurement_configuration"] === undefined
        ? undefined
        : json["related_measurement_configuration"] === null
        ? null
        : json["related_measurement_configuration"],
    geoElectricMeasurement: json["geo_electric_measurement"],
    dataOwner: json["data_owner"],
  };
}

export function GeoElectricMeasureToJSON(json: any): GeoElectricMeasure {
  return GeoElectricMeasureToJSONTyped(json, false);
}

export function GeoElectricMeasureToJSONTyped(
  value?: Omit<GeoElectricMeasure, "uuid" | "created" | "updated"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    resistance: value["resistance"],
    related_measurement_configuration: value["relatedMeasurementConfiguration"],
    geo_electric_measurement: value["geoElectricMeasurement"],
    data_owner: value["dataOwner"],
  };
}
